module.exports = __webpack_public_path__ + "static/media/backgroundLucas.219798d3.jpg";